import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalConfig,
} from '@ng-bootstrap/ng-bootstrap';
import { EditTargetedGroupComponent } from './edit-targeted-group/edit-targeted-group.component';
import { TargetedGroupService } from '../../../business-services/targeted-group.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { TranslateService } from '@ngx-translate/core';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { ToastrService } from 'ngx-toastr';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { TargetGroupRequestModel } from '../../../business-entities/campaign-modal';

@Component({
  selector: 'app-targeted-group',
  templateUrl: './targeted-group.component.html',
  styleUrls: ['./targeted-group.component.css'],
})
export class TargetedGroupComponent implements OnInit {
  //#region Declaration
  userRoleRightsDetails: UserRoleMenu;
  debounceTimer: any;
  totalCount: number = 0;
  scrollDistance = 1;
  throttle = 100;
  targetedGroupList: any;
  requestModal: TargetGroupRequestModel = {
    sortColumn: '',
    sortDirection: '',
    startRecordNumber: 0,
    numberOfRecord: 25,
    searchTerm: '',
  };

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  popupCloseResult = false;
  //#endregion

  constructor(
    private modalService: NgbModal,
    config: NgbModalConfig,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private userService: UserDataService,
    private targetedGroupService: TargetedGroupService
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.requestModal.startRecordNumber = 0;
    this.getTargetedGroups();
    this.userRoleRightsDetails = (
      this.userService.currentUserValue.userRoleMenuDetails as any[]
    ).find((menu) => menu.moduleId === fromEnums.ModuleNames.TargetedGroup);
  }

  //#region API Methods
  getTargetedGroups(isReset: boolean = true) {
    this.spinner.show();
    this.targetedGroupService
      .getTargetedGroups(this.requestModal)
      .then((res: any) => {
        if (isReset) {
          this.targetedGroupList = [];
          this.totalCount = 0;
        }
        if (res?.data.length > 0) {
          this.targetedGroupList.push(...res.data);
          this.totalCount = res.data[0].totalCount;
        }
      })
      .finally(() => this.spinner.hide());
  }
  //#endregion

  //#region Methods
  onSearch() {
    this.requestModal.startRecordNumber = 0;
    this.debounceFunction(() => this.getTargetedGroups(), 200);
  }

  debounceFunction(func, delay) {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(func, delay);
  }

  onScrollDown(_ev) {
    if (this.totalCount > this.targetedGroupList.length) {
      this.requestModal.startRecordNumber = this.targetedGroupList.length;
      this.getTargetedGroups(false);
    }
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.requestModal.sortColumn = column;
    this.requestModal.sortDirection = direction;
    this.requestModal.startRecordNumber = 0;
    this.spinner.show();
    this.getTargetedGroups();
  }

  onEdit(flag: any, tg: any) {
    const modalref = this.modalService.open(EditTargetedGroupComponent, {
      size: 'lg',
      windowClass: 'EditPopup',
    });
    modalref.componentInstance.modelFlag = flag;
    modalref.componentInstance.tgmodel = tg;
    modalref.result.then((response) => {
      if (response?.success) {
        this.ngOnInit();
      }
    });
  }

  onDelete(id: number) {
    let modelHeadermsg = this.translate.instant('lblDelete');
    let modelBodymsg = Utility.createMessage(
      this.translate.instant('lblSureToDelete'),
      this.translate.instant('lblTargetedGroup'),
      false
    );
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      (_result) => {
        // This is intentional
      },
      (reason) => {
        this.popupCloseResult = this.getDismissReason(reason);
        if (this.popupCloseResult) {
          this.targetedGroupService
            .deleteTargetedgroup(id)
            .then((response: any) => {
              if (response && response.statusCode == 201) {
                let deletedmsg = this.translate.instant(
                  'lblTargetedGroupDeleted'
                );
                this.toastr.success(deletedmsg);
                this.getTargetedGroups();
              }
            });
        }
      }
    );
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  //#endregion
}
